const axios = require('axios');

(() => {
  const selectBarbecueOption = '.select-customer-day-camping-option'
  const optionButton = '.day-camping-option-button';
  const eventButton = '.day-camping-event-button';

  const init = () => {
    if (location.href.indexOf('customer/day_camping/option') < 1 ) {
      return
    }
    $('body')
      .on('change', selectBarbecueOption, changePrice)
      .on('click', optionButton, showDayCampingOptionModal)
      .on('click', eventButton, showDayCampingEventModal);
  }

  const changePrice = () => {
    const token = $('meta[name="csrf-token"]').attr('content');
    axios({
      url: process.env.JS_BASE_URL + 'customer/day_camping/option/change',
      method: 'POST',
      data: $('form').serialize(),
      withCredentials: true,
      headers: { 'X-CSRF-Token': token }
    })
    .then(response => {
      $('.plan-block-right').html(response['data'])
    })
    .catch(error => {
      console.log(error);
      return error;
    })
  }

  const showDayCampingOptionModal = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const selectedCampingOptionId = $element[0].dataset.campingOptionId;
    const options = $('#data-day-camping-option').data('day-camping-options');

    options.forEach(option => {
      if (option.id == selectedCampingOptionId) {
        $('.day-camping-option-detail-modal').empty();
        $('.day-camping-option-detail-modal').append(buildOptionModal(option));
      }
    })
  }

  const buildOptionModal = (option) => {
    const taxRate = $('#data-tax').data('tax-rate');
    const charge = option.charge * (1 + taxRate);
    var dayCampingOption =
    `
      <div class="modal-body">
        <div class="title">${option.option_name}</div>
        <div class="price-block">
          <div class="block-left">
            <img src=${option.option_image.admin_show_thumb.url}>
          </div>
          <div class="block-right">
            <div class="price-block">
              <span class="price">${charge.toLocaleString()}</span>
              <span class="unit">円</span>
              <span class="tax">（税込）</span>
            </div>
            <div class="description modal-description">${option.description}</div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success inversion btn-block" data-dismiss="modal">閉じる</button>
      </div>
    `
    return dayCampingOption;
  }

  const showDayCampingEventModal = e => {
    e.preventDefault();
    const $element = $(e.currentTarget);
    const selectedDayCampingEventId = $element[0].dataset.campingEventId;
    const events = $('#data-day-camping-event').data('day-camping-events');

    events.forEach(event => {
      if (event.id == selectedDayCampingEventId) {
        $('.day-camping-event-detail-modal').empty();
        $('.day-camping-event-detail-modal').append(buildCampingEventModal(event));
      }
    })
  }

  const buildCampingEventModal = (event) => {
    const taxRate = $('#data-tax').data('tax-rate');
    const adultCharge = event.adult_charge * (1 + taxRate)
    const kidsCharge = event.kids_charge * (1 + taxRate)
    var dayCampingEvent =
    `
      <div class="modal-body">
        <div class="title">${event.title}</div>
        <div class="price-block">
          <div class="block-left">
            <img src=${event.image.admin_show_thumb.url}>
          </div>
          <div class="block-right">
            <div class="price-block">
              <span>大人</span>
              <span class="price">${adultCharge.toLocaleString()}</span>
              <span class="unit">円</span>
              <span class="tax">（税込）</span>
            </div>
            <div class="price-block">
              <span>子ども</span>
              <span class="price">${kidsCharge.toLocaleString()}</span>
              <span class="unit">円</span>
              <span class="tax">（税込）</span>
            </div>
          </div>
        </div>
        <div class="description modal-description day-camping-event-model-content"><p>${event.content}</p></div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-success inversion btn-block" data-dismiss="modal">閉じる</button>
      </div>
    `
    return dayCampingEvent;
  }
  $(init);
})();
